<template>
  <v-app>
    <nav-drawer v-if="showMenus"></nav-drawer>
    <v-toolbar app absolute clipped-left extended extension-height="7" v-if="showMenus">
        <v-toolbar-side-icon @click.native="toggleDisplayNav"></v-toolbar-side-icon>
        <NavQuickLinks v-if="$vuetify.breakpoint.smAndUp"></NavQuickLinks>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{ subtitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <profile></profile>
        <v-progress-linear slot="extension" :indeterminate="true" v-if="loadingRoute"></v-progress-linear>
    </v-toolbar>
    <v-content class="grey lighten-2">
        <router-view></router-view>
    </v-content>
    <!-- <v-footer class="pa-3">
        <v-spacer></v-spacer>
        <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer> -->
  </v-app>
</template>

<script>

import NavDrawer from "./components/navigation/NavDrawer.vue";
import NavQuickLinks from "./components/navigation/NavQuickLinks.vue";
import Profile from "./components/authentication/Profile.vue";
import auth from './services/auth';

export default {
    components: {
        NavDrawer,
        NavQuickLinks,
        Profile
    },
    data() {
        return {
            
        };
    },
    computed: {
        loadingRoute: function(){
            return this.$store.state.generalStore.loadingRoute;
        },
        subtitle: function() {
            return this.$route.meta.title;
        },
        showMenus(){
            return !this.$route.meta.hideMenus;
        }
    },
    methods: {
        toggleDisplayNav() {
            this.$store.commit("generalStore/toggleDisplayNavDrawer");
        }
    }
};
</script>

<style>
    .v-btn:not(.v-btn--outline).navigation {
        color: white;
    }

    .v-card:not(.v-select-list):not(.v-picker):not(.no-padding) {
        /* soften the edges of most of the site content by adding a bit of spacing */
        margin-bottom: 10px; /* note: this adds an awful line to the bottom of dialogs, which we can stop happening by specifying further :not conditions */
        padding: 10px;
    }

    .dialog-action-buttons .flex {
        /* in dialog popups, just prevent buttons that are side by side from touching each other */
        padding-right: 5px;
        padding-left: 5px;
    }

    .v-dialog .v-toolbar {
        /* just a bit of extra space below the toolbar used in dialog popups  */
        margin-bottom: 10px;
    }

    .v-toolbar__extension {
        padding-left: 0px;
        padding-right: 0px;
    }

    .dialog-content {
        /* prevent the content of dialogs from sitting flush to the edges of the container */
        padding: 10px;
    }

    .printOnlyTableRow {
        display: none;
    }

    .printOnlyTableCell {
        display: none;
    }

    @media print {
        .notPrinted, .v-toolbar, .v-navigation-drawer, .v-btn, div.v-datatable {
            display: none;
        }

        main.v-content {
            display: block;
            -webkit-box-flex: unset;
            flex: unset;
        }

        .v-content {
            padding: 0px !important;
        }

        .container {
            padding: 0px;
            margin: 0px;
            max-width: none;
        }

        .v-card {
            padding: 0px !important;
            margin-bottom: 0px !important;
            border: none;
            box-shadow: none;
            -webkit-box-shadow: none;
        }

        .v-datatable tr {
            page-break-inside: avoid;
        }

        .noBackgroundPrint, .noBackgroundPrint td {
            background: transparent !important;
        }

        .printShowCell {
            display: table-cell;
        }

        .printHideCell {
            display: none;
        }

        .printOnlyTableRow {
            display: table-row;
        }

        .printOnlyTableCell {
            display: table-cell;
        }
       
    }

    @media(max-width: 960px){
        table.v-table thead td:not(:nth-child(1)), 
        table.v-table tbody td:not(:nth-child(1)), 
        table.v-table thead th:not(:nth-child(1)), 
        table.v-table tbody th:not(:nth-child(1)), 
        table.v-table thead td:first-child, 
        table.v-table tbody td:first-child, 
        table.v-table thead th:first-child, 
        table.v-table tbody th:first-child {
            padding: 0px 8px;
        }
    }

    @media only screen and (min-width: 960px) {
        #app .container {
            max-width: 100%;
        }
    }

    /* don't use the standard <a> styling for the menu (blue and underlined) */
    #app .site-menu a {
        text-decoration: none;
        color: inherit;
    }
</style>
